import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { CardVariant, CardView } from "common/views/card/Card.view";
import HeadingView, { HeadingVariant } from "common/views/heading/Heading.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import StringUtil from "core/util/StringUtil";
import { iDef, nDef } from "core/util/TypeUtils";
import { PARAM_USER_ID } from "panels/organizationAdmin/UserList.panel";
import { Config } from "./Config";
import { IIssuedCertificateQueryArgs, IssuedCertificate } from "./entities/IssuedCertificate";
import labelProvider from "./UserCertificates.labels";

const { Labels } = labelProvider;

const CertificatesQuery = Query.queryMany<IssuedCertificate, IIssuedCertificateQueryArgs>(IssuedCertificate);

@Panel({ id: 'user-certificates', configClass: Config, pageParams: true, labelProvider })
export default class CertificatesPanel extends React.PureComponent<IPanelProps<Config>> {

	public render() {
		const { config, pageParams } = this.props;

		const userId = pageParams[PARAM_USER_ID];

		if (nDef(userId)) {
			return (
				<NonIdealState
					title="No User Selected"
					description="Select a user to see their certificates"
				/>
			);
		}

		const defaultPageSize = iDef(config.pageSize) ? config.pageSize : 10;
		const pageSize: number = StringUtil.toInteger(pageParams['certificates.pageSize'], defaultPageSize);

		// TODO supporting paging response in graphql

		return [
			<CertificatesQuery key="query" params={{userIds: [userId]}}>
				{({data, loading}) => {
					if (loading) {
						return <Loading />;
					}

					if (isEmpty(data)) {
						return (
							<NonIdealState
								title={<Labels.NoEarnedCertificates/>}
								description={<Labels.NoEarnedCertificatesDescription/>}
							/>
						);
					}

					return data.map(this.renderCertificate);
				}}
			</CertificatesQuery>
		];
	}

	public renderCertificate = (cert: IssuedCertificate) => (
		<CardView key={cert.id} variant={CardVariant.SURFACE} viewKey="card">
			<FlexJustify>
				<div key="primary" style={{flexGrow: 1}}>
					<HeadingView variant={HeadingVariant.H5} viewKey="cert.name">{cert.certificate.name}</HeadingView>
					<HeadingView viewKey="item.name">{cert.itemName}</HeadingView>
				</div>
				{
					cert.issueDate && (
						<div key="issueDate">
							<Labels.Issued args={{date: cert.issueDate}} />
						</div>
					)
				}
				<div key="actions">
					<ButtonView href={this.getDownloadUrl(cert)} variant={ButtonVariant.PRIMARY} viewKey="button.download">
						<Labels.CertificateDownload />
					</ButtonView>
				</div>
			</FlexJustify>
		</CardView>
	)

	/**
	 * @todo get url as field on IssuedCertificates query
	 */
	private getDownloadUrl = (cert: IssuedCertificate): string => `${window.location.origin}/diweb/catalog/cert/id/${cert.guid}/view/1`;
}



// WEBPACK FOOTER //
// ./src/panels/userCertificates/UserCertificates.panel.tsx